import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexColumn } from '../GridsAndLayouts/GridsAndLayouts';
import Typography from '../Typography';
import './AvatarText.scss';

function renderStackLine(content, className, variant) {
  if (content == null || content === '') return null;
  if (typeof content === 'string' || typeof content === 'number') {
    return (
      <Typography variant={variant} className={className}>
        {content}
      </Typography>
    );
  }
  return <FlexColumn className={className}>{content}</FlexColumn>;
}

const AvatarText = ({
  avatar = '',
  fallback = '',
  title = '',
  subtitle = '',
  size = 'md',
  shape = 'circle',
  fallbackVariant = 'default',
  alt = '',
  withFrame = false,
}) => {
  const mediaFrameClass = [
    'ds-avatar-text__media-frame',
    size !== 'md' && `ds-avatar-text__media-frame--${size}`,
    shape === 'square' && 'ds-avatar-text__media-frame--square',
  ]
    .filter(Boolean)
    .join(' ');

  const avatarClass = [
    'ds-avatar-text__avatar',
    size !== 'md' && `ds-avatar-text__avatar--${size}`,
    shape === 'square' && !withFrame && 'ds-avatar-text__avatar--square',
    withFrame && 'ds-avatar-text__avatar--in-frame',
  ]
    .filter(Boolean)
    .join(' ');

  const fallbackClass = [
    'ds-avatar-text__fallback',
    size !== 'md' && `ds-avatar-text__fallback--${size}`,
    shape === 'square' && !withFrame && 'ds-avatar-text__fallback--square',
    fallbackVariant === 'theme' && 'ds-avatar-text__fallback--theme',
    withFrame && 'ds-avatar-text__fallback--in-frame',
  ]
    .filter(Boolean)
    .join(' ');

  const avatarAlt = alt || (typeof title === 'string' ? title : 'avatar');
  const mediaContent = avatar ? (
    <img src={avatar} alt={avatarAlt} className={avatarClass} />
  ) : (
    <FlexRow align="center" justify="center" inline className={fallbackClass}>
      {fallback}
    </FlexRow>
  );

  return (
    <FlexRow
      align={size === 'sm' ? 'center' : 'start'}
      className={['ds-avatar-text', size !== 'md' && `ds-avatar-text--size-${size}`].filter(Boolean).join(' ')}
    >
      {withFrame ? (
        <FlexRow align="center" justify="center" inline className={mediaFrameClass}>
          {mediaContent}
        </FlexRow>
      ) : (
        mediaContent
      )}
      <FlexColumn className="ds-avatar-text__content">
        {renderStackLine(title, 'ds-avatar-text__title', 'bodyMedium')}
        {renderStackLine(subtitle, 'ds-avatar-text__subtitle', 'bodySmall')}
      </FlexColumn>
    </FlexRow>
  );
};

AvatarText.propTypes = {
  avatar: PropTypes.string,
  fallback: PropTypes.string,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  shape: PropTypes.oneOf(['circle', 'square']),
  fallbackVariant: PropTypes.oneOf(['default', 'theme']),
  alt: PropTypes.string,
  withFrame: PropTypes.bool,
};

AvatarText.defaultProps = {
  avatar: '',
  fallback: '',
  title: '',
  subtitle: '',
  size: 'md',
  shape: 'circle',
  fallbackVariant: 'default',
  alt: '',
  withFrame: false,
};

export default AvatarText;
